<template>
  <x-form
    modal
    :title="$t('Modifica il ricarico per i tuoi clienti')"
    variant="medium"
    :submit-text="$t('Salva')"
    @submit="save"
  >
    <form-group v-for="ccp of categories" :name="ccp.category" :key="ccp.category">
      <x-input
        v-model="ccp.markup"
        :name="ccp.category"
        type="number"
        min="0"
        step="1"
        required
        append="%"
      />
    </form-group>
  </x-form>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { type CategoryCustomPrice, CategoryCustomPricesResource } from "@/resources";
import { cloneDeep } from "lodash-es";
import type XForm from "./x-form.vue";
import type { ComponentProps } from "vue-component-type-helpers";

type XFormProps = ComponentProps<typeof XForm>;

type Props = {
  categoryCustomPrices: CategoryCustomPrice[];
} & /* @vue-ignore */ Omit<XFormProps, "modal" | "title" | "variant" | "submitText" | "onSubmit">;

const props = defineProps<Props>();

const categories = ref(cloneDeep(props.categoryCustomPrices));

const emit = defineEmits<{
  (e: "submit"): void;
}>();

async function save() {
  categories.value = categories.value.map((item) => ({
    category: item.category,
    markup: Number(item.markup),
  }));
  await new CategoryCustomPricesResource().save(categories.value);
  emit("submit");
}
</script>
